var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-simple-checkbox',_vm._b({directives:[{name:"ripple",rawName:"v-ripple"}],model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'v-simple-checkbox',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }